import { request } from "../../../app/api-client/ApiClient";

/**
 * Registra una glucometría. Devuelve la respuesta cruda de request()
 * (envoltorio { codigoRespuesta, respuesta, mensaje }).
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, evbi: Number, glucometria: Number}} datos
 */
export function createGlucometria(dispatch, { numeroDocumento, evbi, glucometria }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/glucometria/create`,
		method: "POST",
		body: JSON.stringify({ numeroDocumento, evbi, glucometria }),
	}, dispatch);
}

/**
 * Historial paginado de glucometrías de un usuario. Devuelve lo que devuelva
 * request(): { error: false, content, page, size, totalElements, totalPages, last }
 * o undefined (HTTP 400 en texto plano / fallo de red).
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, page: Number, size: Number}} params
 */
export function getHistoricoGlucometria(dispatch, { numeroDocumento, page, size }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/glucometria/historico/${encodeURIComponent(numeroDocumento)}?page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}

/**
 * Registra una espirometría.
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, evbi: Number, pef: Number, pred: Number, porcentaje: Number}} datos
 */
export function createEspirometria(dispatch, { numeroDocumento, evbi, pef, pred, porcentaje }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/espirometria/create`,
		method: "POST",
		body: JSON.stringify({ numeroDocumento, evbi, pef, pred, porcentaje }),
	}, dispatch);
}

/**
 * Historial paginado de espirometrías de un usuario. Devuelve lo que devuelva
 * request(): { error: false, content, page, size, totalElements, totalPages,
 * last } o undefined (HTTP 400 en texto plano / fallo de red). Ojo: la fecha de
 * cada elemento viene en datecreated, no en created.
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, page: Number, size: Number}} params
 */
export function getHistoricoEspirometria(dispatch, { numeroDocumento, page, size }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/espirometria/historico/${encodeURIComponent(numeroDocumento)}?page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}

/**
 * Registra un lipidograma.
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, evbi: Number, colesterol: Number, ldl: Number, hdl: Number, trigliceridos: Number}} datos
 */
export function createLipidograma(dispatch, { numeroDocumento, evbi, colesterol, ldl, hdl, trigliceridos }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/lipidograma/create`,
		method: "POST",
		body: JSON.stringify({ numeroDocumento, evbi, colesterol, ldl, hdl, trigliceridos }),
	}, dispatch);
}

/**
 * Historial paginado de lipidogramas de un usuario. Devuelve lo que devuelva
 * request(): { error: false, content, page, size, totalElements, totalPages,
 * last } o undefined (HTTP 400 en texto plano / fallo de red).
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, page: Number, size: Number}} params
 */
export function getHistoricoLipidograma(dispatch, { numeroDocumento, page, size }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/lipidograma/historico/${encodeURIComponent(numeroDocumento)}?page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}

/**
 * Registra un perímetro abdominal.
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, evbi: Number, perimetro: Number}} datos
 */
export function createPerimetroAbdominal(dispatch, { numeroDocumento, evbi, perimetro }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/perimetro-abdominal/create`,
		method: "POST",
		body: JSON.stringify({ numeroDocumento, evbi, perimetro }),
	}, dispatch);
}

/**
 * Historial paginado de perímetros abdominales de un usuario. Devuelve lo que
 * devuelva request(): { error: false, content, page, size, totalElements,
 * totalPages, last } o undefined (HTTP 400 en texto plano / fallo de red).
 * @param {Function} dispatch
 * @param {{numeroDocumento: String, page: Number, size: Number}} params
 */
export function getHistoricoPerimetroAbdominal(dispatch, { numeroDocumento, page, size }) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/perimetro-abdominal/historico/${encodeURIComponent(numeroDocumento)}?page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
